import * as React from 'react'
import qrcode from 'qrcode-generator'

/**
 * A QR code for the printed copy, drawn as SVG squares.
 *
 * Paper and screen meet here: a board member holding the printed proposal
 * scans it to see the photos, change the plan and accept online. Drawn from
 * the module grid as React elements rather than injected markup, so nothing
 * from a string becomes part of the document, and it prints as sharply as
 * the type around it.
 */
export function Qr({ value, className }: { value: string; className?: string }) {
  const cells = React.useMemo(() => {
    const code = qrcode(0, 'M')
    code.addData(value)
    code.make()
    const size = code.getModuleCount()
    const dark: { row: number; col: number }[] = []
    for (let row = 0; row < size; row += 1) {
      for (let col = 0; col < size; col += 1) {
        if (code.isDark(row, col)) dark.push({ row, col })
      }
    }
    return { size, dark }
  }, [value])

  return (
    <svg
      viewBox={`0 0 ${String(cells.size)} ${String(cells.size)}`}
      className={className}
      role="img"
      aria-label="QR code that opens this proposal online"
      shapeRendering="crispEdges"
    >
      <rect width={cells.size} height={cells.size} className="proposal-qr-ground" />
      {cells.dark.map(({ row, col }) => (
        <rect
          key={`${String(row)}-${String(col)}`}
          x={col}
          y={row}
          width={1}
          height={1}
          className="proposal-qr-cell"
        />
      ))}
    </svg>
  )
}
